module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/smartchain_thumb-260359137ae077791f241f95d36543d8.png";